
import { FormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DEFAULT_CONFIG } from '../map/map.component';
@Component({
  selector: 'test-core-tools',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './tools.component.html',
  styleUrl: './tools.component.scss'
})
export class ToolsComponent implements OnInit {
  pluginConfigJson = '';
  error: string | null = null;

  // Default config (should match the default in MapComponent)
  defaultConfig = DEFAULT_CONFIG;

  constructor(private readonly _router: Router) {}

  ngOnInit() {
    const saved = localStorage.getItem('pluginConfigurationMap');
    if (saved) {
      try {
        // Try to parse to ensure it's valid JSON
        JSON.parse(saved);
        this.pluginConfigJson = saved;
      } catch {
        this.pluginConfigJson = JSON.stringify(this.defaultConfig, null, 2);
      }
    } else {
      this.pluginConfigJson = JSON.stringify(this.defaultConfig, null, 2);
    }
  }

  saveConfig() {
    try {
      const parsed = JSON.parse(this.pluginConfigJson);
      localStorage.setItem(
        'pluginConfigurationMap',
        JSON.stringify(parsed, null, 2)
      );
      this.error = null;
      alert('Configuration saved!');
    } catch (e) {
      this.error = 'Invalid JSON: ' + (e as Error).message;
    }
  }

  resetToDefault() {
    this.pluginConfigJson = JSON.stringify(this.defaultConfig, null, 2);
    this.error = null;
  }

  navigateToOtherComponent(path: string[]) {
    this._router.navigate(path);
  }

  refreshJmkw() {
    // Logic to refresh or reinitialize the jmkw component
    // This could involve resetting the state or re-fetching data
    console.log('Refreshing JMKW component...');
  }
}
